import { createSessionStore } from "@/hooks/session-storage/create-session-store";

type SmsCountValue = number | undefined;

type Action = [SmsCountValue, (v: SmsCountValue) => void];

const smsCountStore = createSessionStore<SmsCountValue>(
  "fcm-sms-count",
  undefined
);

/**
 * Hook to manage the SMS count
 * @description smsCount is the number of SMS notifications received from firebase
 *
 * @returns [smsCount, setSmsCount]
 *
 * @author Rajkumar Rathod
 */
const useFcmSmsCount = (): Action => smsCountStore.useStore();

export default useFcmSmsCount;
